
import { LeafletMap } from './map.js';

if( document.getElementById('trouver-etablissement-map') ){
    var map = new LeafletMap('trouver-etablissement-map');
}

var $formEtablissement = $('.search-etablissement-form form');

var updateSearchEtablissementParentType = function(){

    var $selected = $formEtablissement.find('input[name="parenttype"]:checked');
        
    var $selectType = $formEtablissement.find('select[name="type"]');

    if( $selectType.val()!='' ){
        $selectType.val('');
    }

    $selectType.prop('disabled', true).find('option[value!=""]').remove();

    $.ajax({
        url: themeajax.ajaxurl,
        type: "POST",
        dataType:'json',
        data: {
            action: "univi_etablissement_types_ajax_action",
            parenttype: $selected.val()
        },

    }).done(function(response) {

        //console.log(response);

        if( response.types.length>0 ){

            response.types.forEach(function(element){

                $selectType.append('<option value="'+element.term_id+'">'+element.display+'</option>');

            });

            $selectType.prop('disabled', false);

        }            

    });

}

import './pagination.js';

var submitSearchEtablissement = function(displayResultsList){

    var formData = $formEtablissement.serialize();

    $.ajax({
        url: themeajax.ajaxurl,
        type: "POST",
        dataType:'json',
        data: formData,

    }).done(function(response) {
        
        $('.search-etablissement-results').html(response.html);

        //console.log(response);

        map.removeMarkers();

        if( response.pagination.count_results>0 ){

            map.resize();

            //console.log($('.search-etablissement-results .results-list .results-list-item').length);

            let first = true;

            response.results.forEach(function(element){

                if(!element.lat || !element.lng){
                    console.log("Etablissement sans coordonnées GPS : #"+element.id);
                    return;
                }

                let marker = map.addMarker([element.lat, element.lng], element.html, element.color);
                //console.log(marker);

                marker.marker.getElement().addEventListener('click', () => {
                    map.setActiveMarker(marker);
                });
    
                if(first){
                    //map.setActiveMarker(marker);
                }
    
                first = false;

            });

            var $listHtml = '';
            for(var i=1; i<=response.pagination.pages_count; i++){
                $listHtml = $listHtml+'<div data-page="'+i+'"></div>';
            }
            $listHtml = $listHtml+'<ul class="js-pagination"></ul>';

            $('.form-results-list').html($listHtml);

            response.results.forEach(function(element){
                element.html = element.html.replaceAll('carousel-etablissement-'+element.id, 'carousel-etablissement-'+element.id+'-bis');
                $('.form-results-list').find('[data-page="'+element.page+'"]').append('<div class="form-results-item">'+element.html+'</div>');
            });

            if(response.pagination.pages_count>1){
                $('.form-results-list').find('[data-page][data-page!="1"]').hide();
                $('.form-results-list').find('.js-pagination').pagination({
                    pages: response.pagination.pages_count,
                    displayedPages: 5,
                    edges: 1,
                    currentPage: 1,
                    prevText: '<',
                    nextText: '>',
                    ellipsePageSet: false,
                    onPageClick(pageNumber, event){
                        $('.form-results-list').find('[data-page]').hide();
                        $('.form-results-list').find('[data-page="'+pageNumber+'"]').show();
                        $('.form-results-list').scrollTop(0);
                    }
                });
            }else{
                $('.form-results-list .js-pagination').remove();
            }

            $('.form-results-filters-button').show();

        }else{
            $('.form-results-list').html('<div class="noresult"><b>Aucun résultat</b><br />Essayez de modifier vos critères de recherche en supprimant des filtres ou en modifiant le critère géographique.</div>');

            $('.form-results-filters-button').hide();
        }

        $('.form-results').removeClass('color-rouge color-violet color-orange').addClass("color-"+response.color);

        if( response.pagination.count_results>0 && !response.map.bounds ){
            map.autoCenter();

        }else{                

            if( response.map.bounds){
                map.setBounds(
                    response.map.bounds.latitude_min, 
                    response.map.bounds.latitude_max, 
                    response.map.bounds.longitude_min, 
                    response.map.bounds.longitude_max
                );
            }
            
        }

        if(displayResultsList){

            $formEtablissement.find('.form-secondary-fields').hide();
            $formEtablissement.find('.form-results').show();

        }else{
            $formEtablissement.find('.form-secondary-fields').show();
            $formEtablissement.find('.form-results').hide();
        }

    });
}

var previewSubmitFiltersEtablissement = function(){

    var formData = $formEtablissement.serialize();

    $.ajax({
        url: themeajax.ajaxurl,
        type: "POST",
        dataType:'json',
        data: formData,

    }).done(function(response) {

        //console(response);

        var $button = $('#searchFormFiltersModal .modal-footer button[type="submit"]');

        if( response.pagination.count_results > 1 ){
            $button.find('.inner').text("Afficher "+response.pagination.count_results+" établissements");
            $button.prop('disabled', false);
        }else if( response.pagination.count_results == 1 ){
            $button.find('.inner').text("Afficher "+response.pagination.count_results+" établissement");
            $button.prop('disabled', false);
        }else{
            $button.find('.inner').text("Aucun établissement");
            $button.prop('disabled', true);
        }

    });
}

$formEtablissement.on('click', 'a.back', function(e){
    e.preventDefault();
    $formEtablissement.find('.form-secondary-fields').show();
    $formEtablissement.find('.form-results').hide();
});

$formEtablissement.find('input[name^="filters"]').change(function(e){
    e.preventDefault();
    previewSubmitFiltersEtablissement();

    var countFilters = $formEtablissement.find('input[name^="filters"]:checked').length;
    if(countFilters>0){
        $formEtablissement.find('.modal-clear-form').removeClass('disabled');
    }else{
        $formEtablissement.find('.modal-clear-form').addClass('disabled');
    }
});

$formEtablissement.on('click', '.modal-clear-form', function(e){
    e.preventDefault();
    $(this).parents('.modal-dialog').find('input[type="checkbox"]').prop('checked', false);
    previewSubmitFiltersEtablissement();
    $(this).addClass('disabled');
});

$formEtablissement.find('input[name="parenttype"]').on('change', function(){

    var $input = $(this);

    if( $input.is(':checked') ){

        $formEtablissement.find('input[name="parenttype"]').not($input).prop('checked', false);

        // Santé : on affiche directement les résultats
        if( $input.parent().hasClass('color-orange') ){
            updateSearchEtablissementParentType();

            submitSearchEtablissement(false);

        }else{
            submitSearchEtablissement(true);
        }

        

    }

});

var updateSearchEtablissementRegion = function(){

    var $selectDepartement = $formEtablissement.find('select[name="departement"]');

    $selectDepartement.prop('disabled', true).find('option[value!=""]').remove();

    var regionCode = $formEtablissement.find('select[name="region"]').val();

    $.ajax({
        url: themeajax.ajaxurl,
        type: "POST",
        dataType:'json',
        data: {
            action: "univi_etablissement_departements_ajax_action",
            region: regionCode
        },

    }).done(function(response) {

        //console.log(response.departements);

        Object.values(response.departements).forEach(function(element){
            $selectDepartement.append('<option value="'+element.term_id+'" data-region="'+element.parent+'">'+element.name+'</option>');
        });

        $selectDepartement.prop('disabled', false);       

    });

    submitSearchEtablissement(false);

}

$formEtablissement.find('select[name="region"]').on('change', function(){
    updateSearchEtablissementRegion();
});


$formEtablissement.find('select[name="departement"]').on('change', function(){

    var regionCode = $formEtablissement.find('select[name="departement"] option:selected').attr('data-region');

    $formEtablissement.find('select[name="region"]').val(regionCode);

    submitSearchEtablissement(false);
});


$formEtablissement.on('submit', function(e){
    e.preventDefault();

    submitSearchEtablissement(true);
});


updateSearchEtablissementParentType();
submitSearchEtablissement(false);


$('.results-map .toggle_results_list').on('click', function(e){
    e.preventDefault();

    $(this).toggleClass('active');
    $('.results-list').parent().toggleClass('d-none');
    $('.results-map').parent().toggleClass('col-md-5');

    map.resize();
});


$formEtablissement.on('click', '.js-form-filter-link', function(e){
    e.preventDefault

    $(this).toggleClass('btn-primary btn-outline-primary active');

    const bool = $(this).hasClass('active');

    let $cbfilter = $formEtablissement.find('input[name="filters['+$(this).data('taxonomy')+'][]"][value="'+$(this).data('term_id')+'"]');

    $cbfilter.prop('checked', bool);

    $formEtablissement.trigger("submit");

});
